import { Divider } from '@mui/material';
import React from 'react';

export interface RowDividerProps {
  noLine?: boolean;
  mt?: number | string;
  mb?: number | string;
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  children?: React.ReactNode;
}

const UnMemoRowDivider: React.FC<RowDividerProps> = ({
  mt = 3,
  mb = 3,
  noLine = false,
  orientation = 'horizontal',
  className = '',
  children,
}) => {
  const textSeparatorLineClasses = `w-full h-[1px] bg-non-hover-border`;
  const mtValue = typeof mt === 'number' ? `${mt * 8}px` : mt;
  const mbValue = typeof mb === 'number' ? `${mb * 8}px` : mb;

  return (
    <div
      className={`w-full ${className}`}
      style={{ marginTop: mtValue, marginBottom: mbValue }}
    >
      {!noLine && !children && <Divider orientation={orientation} />}
      {/* When text is defined, render divider with text. */}
      {children && (
        <div className="flex flex-row items-center gap-[8px] justify-between mt-[20px]">
          <div className={textSeparatorLineClasses} />
          {children}
          <div className={textSeparatorLineClasses} />
        </div>
      )}
    </div>
  );
};

export const RowDivider = React.memo(UnMemoRowDivider);

export default RowDivider;
